import { ProjectDocumentDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProjectDocumentActions from './project-document.actions';

export const PROJECT_ACTIVITY_FEATURE_KEY = 'projectDocument';

export interface ProjectDocumentState extends EntityState<ProjectDocumentDto> {
  selectedProjectDocumentId?: string | number; // which ProjectDocument record has been selected
  loaded: boolean; // has the ProjectDocument list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProjectDocumentPartialState {
  readonly [PROJECT_ACTIVITY_FEATURE_KEY]: ProjectDocumentState;
}

export const projectDocumentAdapter: EntityAdapter<ProjectDocumentDto> = createEntityAdapter<
  ProjectDocumentDto
>({
  selectId: (projectDocument) => projectDocument.id,
  sortComparer: false,
});

export const initialState: ProjectDocumentState = projectDocumentAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProjectDocumentId: null,
  }
);

const projectDocumentReducer = createReducer(
  initialState,
  on(ProjectDocumentActions.loadProjectDocument, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectDocumentActions.loadProjectDocumentSuccess,
    (state, { projectDocument }) =>
      projectDocumentAdapter.addAll(projectDocument, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectDocumentActions.loadProjectDocumentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProjectDocumentActions.addProjectDocument, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectDocumentActions.addProjectDocumentSuccess,
    (state, { newProjectDocument }) =>
      projectDocumentAdapter.addMany(newProjectDocument, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectDocumentActions.addProjectDocumentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(ProjectDocumentActions.updateProjectDocument, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectDocumentActions.updateProjectDocumentSuccess,
    (state, { updateProjectDocument }) =>
      projectDocumentAdapter.upsertMany(updateProjectDocument, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ProjectDocumentActions.updateProjectDocumentFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  // search student

  on(ProjectDocumentActions.searchProjectDocumentRecord, (state, { query }) => {
    return {
      ...state,
      selectedProjectDocumentId: query,
      loaded: false,
      error: null,
    };
  }),
  on(ProjectDocumentActions.removeProjectDocument, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProjectDocumentActions.removeProjectDocumentSuccess, (state, { ids }) =>
    projectDocumentAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(
    ProjectDocumentActions.removeProjectDocumentFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  )
);

export function reducer(
  state: ProjectDocumentState | undefined,
  action: Action
) {
  return projectDocumentReducer(state, action);
}
